import { useCallback } from 'react';
import { SMLUpgradeFeature } from '../../config/music24PlanCapabilities';
import { useUpgradePrompt } from '../../hooks/useUpgradePrompt';
import { useIsUpsellMember } from '../../watermarkUpsell/useIsUpsellMember';

/**
 * Upgrade of the Profile (design a2, c2.7): a Free preview has the Music24 mark, a paid plan makes
 * the clean full-size file. Only the owner upgrades (D11): a member reads "Ask the owner to upgrade".
 */
export function useProfileUpgrade(): { isMember: boolean; upgrade: () => void } {
  const isMember = useIsUpsellMember();
  const prompt = useUpgradePrompt();
  const upgrade = useCallback(() => prompt(SMLUpgradeFeature.watermark), [prompt]);
  return { isMember, upgrade };
}
